export default "__VITE_ASSET__Bl3l33hD__"